export { NanoLineChart } from './line-chart';
export type { LineChartConfig } from './line-chart';
export { NanoBarChart } from './bar-chart';
export type { BarChartConfig } from './bar-chart';
export { NanoPieChart } from './pie-chart';
export type { PieChartConfig } from './pie-chart';

import { NanoLineChart } from './line-chart';
import { NanoBarChart } from './bar-chart';
import { NanoPieChart } from './pie-chart';

// UMD-style globals for script-tag usage
if (typeof window !== 'undefined') {
  (window as any).NanoLineChart = NanoLineChart;
  (window as any).NanoBarChart = NanoBarChart;
  (window as any).NanoPieChart = NanoPieChart;
}
